<template>
    <div class="history">
        <rc-table ref="rcTable"
                  :tableAttr="tableAttr" />
        <!-- <historyModal ref="historyModal" /> -->
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api'
// import historyModal from './historyModal'
export default {
    name: 'history',
    props: ['isLocak', 'baseInfo'],
    components: {
        rcTable
        // historyModal
    },
    data () {
        return {
            tableAttr: {
                hideHead: true,
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ACTION_LOG, true),
                    params: {
                        resSid: this.$route.params.id
                    }
                },
                columns: [
                    {
                        key: 'resType',
                        title: this.$i18n.t('操作类型'),
                        className: 'rc-ellipsis',
                        render: (h, params) => {
                            return h('span', params.row.resType + ' ' + this.$i18n.t(this.getOperateName(params.row.opType)))
                        }
                    },
                    {
                        key: 'opUser',
                        title: this.$i18n.t('操作人'),
                        className: 'rc-ellipsis'
                    },
                    {
                        key: 'orgName',
                        title: this.$i18n.t('组织名称'),
                        className: 'rc-ellipsis'
                    },
                    {
                        key: 'opDate',
                        title: this.$i18n.t('操作时间'),
                        className: 'rc-ellipsis'
                    }
                ]
            }
        }
    },
    methods: {
        // detailFun (row) {
        //     this.$refs.historyModal.openModal(row)
        // },
        getOperateName (operate) {
            switch (operate) {
                case 'import':
                    return '导入'
                case 'create':
                    return '创建'
                case 'delete':
                    return '删除'
                case 'attach':
                    return '挂载'
                case 'detach':
                    return '卸载'
                case 'alloc':
                    return '关联'
                case 'un_alloc':
                    return '取消关联'
                case 'modify':
                    return '更新'
                case 'clone':
                    return '克隆'
                case 'roll_back':
                    return '回滚'
                case 'restart':
                    return '重启'
                case 'start':
                    return '启动'
                case 'stop':
                    return '停止'
                case 'reboot':
                    return '重启'
                case 'pause':
                    return '暂停'
                case 'un_pause':
                    return '取消暂停'
                case 'suspend':
                    return '挂起'
                case 'resume':
                    return '继续'
                case 're_config':
                    return '重新配置'
                case 'disable':
                    return '禁用'
                case 'enable':
                    return '启用'
                case 'relation_cloudenv':
                    return '关联云环境'
                case 'remove_cloudenv':
                    return '移除云环境'
                case 'execscript':
                    return '执行脚本'
                case 'add_host':
                    return '增加主机'
                case 'remove_host':
                    return '移除主机'
                case 'recover':
                    return '恢复'
                case 'recycle':
                    return '放入回收站'
                case 'clearbin':
                    return '清空回收站'
                case 'resetPassword':
                    return '重置密码'
                case 'config_sg':
                    return '配置安全组'
                case 'resetHostName':
                    return '修改系统名称'
                default:
                    return operate
            }
        }
    }
}
</script>
